import FeatureCarousel from './FeatureCarousel';
export default FeatureCarousel;
